import { BADGE_VARIANTS } from 'components/Badge'
import { type StatusBadgeMapper } from './types'

export const BOOLEAN_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  true: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'TRUE',
  },
  false: {
    variant: BADGE_VARIANTS.RED,
    text: 'FALSE',
  },
} as const
